import React from 'react'
import PatientViewer from './PatientViewer'
import { bindActionCreators } from 'redux'
import {patientActions} from '../../../../redux/patient/index'
import {currentSelectionActions} from '../../../../redux/currentSelection/index'
import { connect } from 'react-redux'
import Patient from '../../../../models/Patient/Patient'
import { demoApp } from '../../../../config'
import {notify, removeNotifications} from 'reapop'
import withPolyglot from '../../../common/withPolyglot'

const DEMO_NOTIFICATION_ID = 999

class PatientViewerContainer extends React.Component {
  componentDidMount () {
    const { match, selectPatient, patientStatus } = this.props
    if (!patientStatus.data) {
      selectPatient(match.params.patientId)
    } else if (patientStatus.data.id !== match.params.patientId) {
      selectPatient(match.params.patientId)
    }
  }

  componentWillUnmount () {
    this.props.removeCurrentSelections()
    this.props.removePatient()
  }

  componentDidUpdate () {
    const { notifications, notify } = this.props
    if (demoApp) {
      if (!notifications.find(n => n.id === DEMO_NOTIFICATION_ID)) {
        notify({
          id: DEMO_NOTIFICATION_ID,
          title: this.props.translate('title', true, 'demo'),
          message: this.props.translate('description', true, 'demo'),
          status: 'info',
          dismissible: false,
          dismissAfter: 0,
          position: 'bl',
          closeButton: false,
          allowHTML: true,
          buttons: []
        })
      }
    }
  }
  render () {
    const { patientStatus, selectEmptyInsertion, removeEmptyInsertion, match, selectPreviousInsertion } = this.props
    if (patientStatus.fetching) {
      return <div className='uk-container uk-padding-small'>Loading</div>
    } else if (patientStatus.data) {
      const {id, name, birthDate, gender, photo, country} = patientStatus.data
      const patient = new Patient(id, name, birthDate, gender, photo, country)
      return <PatientViewer
        selectPreviousInsertion={selectPreviousInsertion}
        selectEmptyInsertion={selectEmptyInsertion}
        removeEmptyInsertion={removeEmptyInsertion}
        match={match}
        patient={patient} />
    } else {
      return <div className='uk-container uk-padding-small'>Patient Not Found</div>
    }
  }
}

function mapStateToProps ({patient, notifications}) {
  return {
    patientStatus: patient,
    notifications
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...patientActions, ...currentSelectionActions, notify, removeNotifications}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withPolyglot(PatientViewerContainer))
